import { render } from "./country-switcher.vue?vue&type=template&id=340624b1"
import script from "./country-switcher.vue?vue&type=script&lang=js"
export * from "./country-switcher.vue?vue&type=script&lang=js"

import "./country-switcher.vue?vue&type=style&index=0&id=340624b1&lang=scss"

import exportComponent from "/Users/connoringold/Documents/projects/bao/toteme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__